export class Refund {
    id: number;
    transactionId: string;
    createdBy: any;
    createdTime: Date;
    refundAmount: number;
    refundStatus: string;
    comments: string;
    accountId: number;
    orgId: number;
    subscriptions: any[]
}